import React from 'react';

const ResponsiveInline = (props: any) => {
    const { content } = props;

      return (
        <div className="block">
          <div className="flex w-full items-center justify-center pt-50">
            <div className="w-full max-w-screen-xl px-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                {content.cards.map((card: any, index: number) => {
                  const title = card.title || 'Untitled';
                  const description = card.description || '';
                  const imageUrl = card.image?.url || '';
                  const imageAlt = card.image?.title || title;
                  const linkHref = card.ctas?.[0]?.link?.href || '#';
                  const openInNewTab = card.ctas?.[0]?.open_in_new_tab || false;

                  return (
                    <div key={index} className="hover:shadow-lg transition-shadow" style={{ backgroundColor: 'white' }}>
                      <a
                        href={linkHref} target={openInNewTab ? '_blank' : '_self'} rel={openInNewTab ? 'noopener noreferrer' : undefined} 
                        className="group block hover:bg-[#D9D9D9]" >
                        {imageUrl && (
                          <img src={imageUrl} alt={imageAlt} className="w-full h-[400px] object-cover" />
                        )}

                        <div className="p-4 text-left">
                          <h1 className="text-lg font-bold text-gray-800">{title}</h1>
                          {description && (
                            <p className="text-sm text-gray-600 mt-2">{description}</p>
                          )}

                          <div className="mt-4 text-right transform transition-transform duration-300 group-hover:translate-x-4">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="green" >
                              <path d="M18 9L25 16M25 16L18 23M25 16L7 16"
                                stroke="#666666" className="hidden group-hover:stroke-[#090909] md:block" strokeWidth="2" strokeLinecap="square" />
                            </svg>
                          </div>
                        </div>
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
    )
};

export default ResponsiveInline;

